import editorEn from '../Editor/i18n.en';

const translations = {
  ...editorEn,
};

export default translations;
